import { render, staticRenderFns } from "./grossing-touch-assays-sidepanel.vue?vue&type=template&id=122e82c3&scoped=true&"
import script from "./grossing-touch-assays-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-assays-sidepanel.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-assays-sidepanel.scss?vue&type=style&index=0&id=122e82c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e82c3",
  null
  
)

export default component.exports